import { BASE_URL } from '../constants'

const token = JSON.parse(localStorage.getItem('token'))

export const getRegisterFlagsList = () => {
  const URL = `${BASE_URL}flags/registration/list`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const getRegisterFlagOne = (flagId) => {
  const URL = `${BASE_URL}flags/registration/one?flagId=${flagId ?? ''}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const createRegisterFlag = async (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}flags/registration/create`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    const res = await response.json()

    return { response, res }
  } catch (error) {
    console.log(error)
  }
}

export const updateRegisterFlag = async (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}flags/registration/update`

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    const res = await response.json()

    return { response, res }
  } catch (error) {
    console.log(error)
  }
}

export const deleteRegisterFlag = async (flagId) => {
  const URL = `${BASE_URL}flags/registration/delete?flagId=${flagId ?? ''}`

  try {
    const response = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })

    const res = await response.json()

    return { response, res }
  } catch (error) {
    console.log(error)
  }
}

export const getRegisteredTalentsByFlag = ({
  flagId = '',
  dateFrom = '',
  dateTo = '',
  page = '',
} = {}) => {
  const URL = `${BASE_URL}flags/registration/talents?flagId=${flagId}&dateFrom=${dateFrom}&dateTo=${dateTo}&page=${page}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}
